import {TextField} from '@mui/material';
import {makeStyles, styled} from '@mui/styles';
import {useState} from 'react';
import {digitsEnToFa} from 'persian-tools2';

import styles from 'assets/jss/FormikField.js';
import WheelWrapper from '../WheelPicker/WheelWrapper';
const useStyles = makeStyles(styles);

const WheelTextField = ({name, label, values, setFieldValue}) => {
  const classes = useStyles();

  const [showToast, setShowToast] = useState(false);

  const openToastHandler = () => setShowToast(true);
  const closeToastHandler = () => {
    setShowToast(false);
    setFieldValue(name, values[name]);
  };

  const changeHandler = (value) => {
    setFieldValue(name, value);
    setShowToast(false);
  };

  const diabetValueText =
      values[name] !==0 && values[name]?`${values[name]} سال`:
    values[name] === 0 ? ` زیر یک سال` : '';

  const value =
    values[name] === null
      ? '_'
      : name === 'yearsWithDiabet'
      ? digitsEnToFa(diabetValueText)
      : digitsEnToFa(values[name]);

  const wheelpickerProps = {
    value: values[name],
    showToast,
    changeHandler,
    openToastHandler,
    closeToastHandler,
    label,
  };

  // remove highlited background
  const CustomTextField = styled(TextField)({
    '& label.Mui-focused': {
      color: '#753CBE',
    },
  });

  return (
    <>
      <div className={classes.parentTextField}>
        <div className={classes.textFieldMarker}>{label} :</div>
        <CustomTextField
          fullWidth
          name={name}
          value={value}
          onClick={() => {
            if (showToast) return;
            openToastHandler();
          }}
          className={classes.textfied}
          inputProps={{
            style: {
              textAlign: 'left',
              letterSpacing: name === 'birthDate' ? '1.5px' : '',
            },
          }}
        />
      </div>
      {showToast && <WheelWrapper {...wheelpickerProps} name={name} />}
    </>
  );
};

export default WheelTextField;
